import { FC, ReactNode } from "react";

import { VnBox } from "@/components/VnBox";
import { VnText } from "@/components/VnText/VnText";
import { OnboardingTextType } from "@/utils/onboarding";

type PhotoCardHeaderPropsType = {
  icon: ReactNode;
  title: OnboardingTextType;
  description: OnboardingTextType;
};

export const PhotoCardHeader: FC<PhotoCardHeaderPropsType> = ({
  icon,
  title,
  description,
}) => (
  <VnBox className="gap-3">
    <VnBox className="flex-row items-center gap-3">
      {icon}
      <VnText
        variant="lgBold"
        className="flex-1 text-xl text-white"
        {...title}
      />
    </VnBox>
    <VnText variant="lg" className="text-white" {...description} />
  </VnBox>
);
